import { render, staticRenderFns } from "./SportCard.vue?vue&type=template&id=288e6c03&"
import script from "./SportCard.vue?vue&type=script&lang=js&"
export * from "./SportCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports